import { c as _c } from "react/compiler-runtime";
import KommerPoster from 'src/components/kommendefilmer/KommerPoster';
import KommerTextRow from 'src/components/kommendefilmer/KommerTextRow';
import SPosterContainer from 'src/components/kommendefilmer/PosterContainer';
import SSectionTitle from 'src/components/kommendefilmer/SectionTitle';
import STextListContainer from 'src/components/kommendefilmer/TextListContainer';
import { isPremiereThisWeek } from 'src/components/kommendefilmer/helperFunctions';
import styles from './PremieresThisWeek.module.css';
import type { ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';
import { locale } from "@locale";

//#region [Props]
type PremieresThisWeekProps = {
  showTextList?: boolean;
} & ILoaderMoviesProps;
//#endregion

//#region [Component]
export default function PremieresThisWeek(t0) {
  const $ = _c(6);
  const {
    movies,
    showTextList: t1
  } = t0;
  const showTextList = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== movies || $[1] !== showTextList) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const _movies = movies?.filter(_temp);
      if ((_movies?.length ?? 0) === 0) {
        t3 = null;
        break bb0;
      }
      if (showTextList) {
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <SSectionTitle className={styles.SPageSectionTitle}>{locale.kommer.premThisWeekHeading}</SSectionTitle>;
          $[4] = t4;
        } else {
          t4 = $[4];
        }
        t3 = <STextListContainer>{t4}{_movies?.map(_temp2)}</STextListContainer>;
        break bb0;
      }
      let t4;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <SSectionTitle className={styles.SPageSectionTitle}>{locale.kommer.premThisWeekHeading}</SSectionTitle>;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t2 = <SPosterContainer className={styles.PosterGrid}>{t4}{_movies?.map(_temp3)}</SPosterContainer>;
    }
    $[0] = movies;
    $[1] = showTextList;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}
//#endregion
function _temp3(movie_0) {
  return <KommerPoster key={movie_0.mainVersionId} film={movie_0} dateFormat="thisweek" width={235} forceTicketButton={true} />;
}
function _temp2(movie) {
  return <KommerTextRow key={movie.mainVersionId} film={movie} dateFormat="thisweek" />;
}
function _temp(m) {
  return !!m.sanityImagePosterUrl && isPremiereThisWeek(m);
}